
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface PerformanceChartProps {
  title: string;
  description: string;
  data: any[];
  metricName: string;  // 'fps' or 'memory'
}

const PerformanceChart = ({ title, description, data, metricName }: PerformanceChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="displayTime" 
                label={{ value: 'Time', position: 'insideBottomRight', offset: 0 }} 
              />
              <YAxis 
                label={{ 
                  value: metricName === 'fps' ? 'FPS' : 'MB', 
                  angle: -90, 
                  position: 'insideLeft' 
                }} 
              />
              <Tooltip />
              <Legend />
              <Line 
                type="monotone" 
                dataKey="value" 
                stroke={metricName === 'fps' ? "#8BAF96" : "#FF9A8B"} 
                name={metricName === 'fps' ? 'FPS' : 'Memory (MB)'} 
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default PerformanceChart;
